// document.addEventListener('DOMContentLoaded', function () {
//   // Only for desktop nav
//   if (window.matchMedia('(min-width: 1024px)').matches) {
//     // All parent items with submenu
//     const menuParents = document.querySelectorAll(
//       '.localads-header-top__nav .menu-item-has-children'
//     );

//     menuParents.forEach(parent => {
//       // You want click on link or button to toggle submenu
//       const link = parent.querySelector('a');
//       const toggleBtn = parent.querySelector('.sub-menu-toggle');

//       // Prevent default for # links
//       link.addEventListener('click', function (e) {
//         // Only trigger for href="#"
//         if (link.getAttribute('href') === '#') {
//           e.preventDefault();
//           togglePopover(parent);
//         }
//       });

//       if (toggleBtn) {
//         toggleBtn.addEventListener('click', function (e) {
//           e.preventDefault();
//           togglePopover(parent);
//         });
//       }
//     });

//     // Helper to toggle
//     function togglePopover(li) {
//       // Close any other open popovers
//       document
//         .querySelectorAll('.localads-header-top__nav .menu-item-has-children.open-popover')
//         .forEach(openLi => {
//           if (openLi !== li) openLi.classList.remove('open-popover');
//         });

//       li.classList.toggle('open-popover');
//     }

//     // Click outside closes all
//     document.addEventListener('click', function (e) {
//       const openLi = document.querySelector('.localads-header-top__nav .menu-item-has-children.open-popover');
//       if (openLi && !openLi.contains(e.target)) {
//         openLi.classList.remove('open-popover');
//       }
//     });

//     // ESC key closes all
//     document.addEventListener('keydown', function (e) {
//       if (e.key === 'Escape') {
//         document
//           .querySelectorAll('.localads-header-top__nav .menu-item-has-children.open-popover')
//           .forEach(li => li.classList.remove('open-popover'));
//       }
//     });
//   }
// });
